export default {"src":"/_next/static/media/signal.1d0f934a.svg","height":93,"width":94,"blurWidth":0,"blurHeight":0};